import React from 'react'
import {Container} from 'react-bootstrap';
import withAuth from '../components/authHOC';
import SavingsTable from '../components/SavingsTable';

const LoansPage = () => {
    
  return (
       <Container fluid id='users-container'>
       
        <SavingsTable></SavingsTable>
    </Container>
  )
}
export default withAuth (LoansPage, ['admin', 'agent'])